module.exports = new __parcel__URL__("email.very-specific-illu.34a3a65d.png").toString();